import React from 'react';
import type { DisallowStyleProps } from '@balance-web/utils';

import type { IndicatorToneColors } from './useToneColor';
import { useIndicatorToneColor } from './useToneColor';

export type IndicatorDotProps = {
  /**
   * When the intent isn't provided by text, you must supply an "aria-label" for
   * assistive tech users.
   */
  'aria-label'?: string;
} & DisallowStyleProps & {
    tone: IndicatorToneColors;
    size?: 'xsmall' | 'small' | 'medium';
  };

/** A small decorative indicator used to call attention to an item. */
export const IndicatorDot = ({
  'aria-label': ariaLabel,
  tone,
  size = 'medium',
}: IndicatorDotProps) => {
  const toneColor = useIndicatorToneColor({ tone });

  const resolvedSize = size === 'xsmall' ? 6 : 8;

  return (
    <div
      aria-label={ariaLabel}
      style={{
        backgroundColor: toneColor.backgroundColor,
        borderRadius: resolvedSize,
        height: resolvedSize,
        width: resolvedSize,
        flexShrink: 0,
      }}
    />
  );
};
